import * as types from "./mutation-types";

const mutations = {
  [types.SET_IS_ADMIN](state, status) {
    state.isAdmin = status;
  },

  [types.SET_IS_WT_ADMIN](state, status) {
    state.isWtAdmin = status;
  },

  [types.SET_IS_WT_ADMIN_SUPER](state, status) {
    state.isWtAdminSuper = status;
  },

  [types.SET_IS_NON_ADMIN](state, status) {
    state.isNonAdmin = status;
  },

  [types.SET_EMAIL_NOT_CONFIRMED](state, status) {
    state.emailNotConfirmed = status;
  },

  [types.SET_PASSWORD_CHANGED](state, status) {
    state.passwordChanged = status;
  },

  [types.SET_IS_TEAM_LEADER](state, status) {
    state.isTeamLeader = status;
  }
};

export default mutations;
